'use strict';

module.exports = require('./slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/._react-slick@0.14.7@react-slick/lib/index.js
 ** module id = 674
 ** module chunks = 0 1
 **/